import React, { useMemo } from 'react';
import Col from "react-bootstrap/Col";
import { Form } from 'react-bootstrap';
import { ScoringInputType } from "../../models/enums/ScoringInputType";

const PlayerUpdateList = (props) => {

    const { selectedPlayer
        , selectedScore
        , isMultipleChoiceForPlayer
        , setSelectedEditPlayer
        , selectedMultipleString
        , selectedString
        , selectedEditPlayer
        , homeTeamPlayers
        , awayTeamPlayers
        , inputItemList
        } = props;

    const optionPlayers = x => ({id: x.shirtNumber ?? x.teamId, key: x.key})
    const playersFilterRedYellowCard = x=> (x.type === ScoringInputType.RedCard || x.type === ScoringInputType.YellowCard) && selectedPlayer?.time > x.time
    const playersFilterReturnRedYellowCard = x=> (x.type === ScoringInputType.RedCardReturned || x.type === ScoringInputType.YellowCardReturned) && selectedPlayer?.time > x.time

    const playersListOption = useMemo(()=>{
        const playersList = homeTeamPlayers?.map(optionPlayers)?.concat(awayTeamPlayers?.map(optionPlayers))
        const timeRedYellowCard = inputItemList?.filter(playersFilterRedYellowCard)
        const timeReturnRedYellowCard = inputItemList?.filter(playersFilterReturnRedYellowCard)

        const playersReturn = timeRedYellowCard?.filter((x)=> !timeReturnRedYellowCard?.find(y => y.id === x.id))   
        
        return playersList?.filter((x)=> !playersReturn?.find(y => y.playerScoreKey === x.key))

    },[inputItemList,homeTeamPlayers,awayTeamPlayers,selectedPlayer])
    
    const multiplePlayersListOption = useMemo(()=>{
        const multiplePlayersOption = x => ({id: x.shirtNumber, key: x.key, teamId: x.teamId})
        const multiplePlayersList = homeTeamPlayers?.map(multiplePlayersOption).concat(awayTeamPlayers?.map(multiplePlayersOption))
                                    ?.filter(x => !selectedPlayer?.groupPlayerScoresKey?.includes(x.key) && x?.teamId === selectedPlayer?.teamId && x?.id != x?.teamId)
        const timeRedYellowCard = inputItemList?.filter(playersFilterRedYellowCard)
        const timeReturnRedYellowCard = inputItemList?.filter(playersFilterReturnRedYellowCard)                 
        const multiplePlayersReturn = timeRedYellowCard?.filter((x)=> !timeReturnRedYellowCard?.find(y => y.id === x.id))

        return multiplePlayersList?.filter(x => !multiplePlayersReturn?.find(y => y.playerScoreKey === x.key ))
    },[inputItemList,homeTeamPlayers,awayTeamPlayers,selectedPlayer])

    const halfStateText = useMemo(() => {
        return (
            selectedPlayer?.categorizations && (
                <div style={{display:'inline-flex'}}>
                    <Form.Control as ="select"
                        size="sm"
                        value={selectedEditPlayer} 
                        onChange={(event) => { setSelectedEditPlayer(event.target.value) }}
                        style={{ width: '120px', color: 'black', fontWeight: 'bold', textAlignLast: 'center' }}
                    > 
                        <option value={selectedPlayer?.key} hidden>{selectedPlayer?.key}</option>
                        {
                            selectedPlayer?.groupPlayerScoresKey ?
                            (
                                multiplePlayersListOption?.map(({ id, key }, index) => <option value={id} key={id}>{key}</option>)
                            )
                            :
                            (
                                playersListOption.map(({ id, key }, index) => <option value={id} key={id}>{key}</option>)
                            )
                        }
                    </Form.Control>
                </div>
            )
        );
    }, [selectedPlayer?.key]);

    return <>
        <Col className="py-1">
            {isMultipleChoiceForPlayer ? <span>Selected: </span> : selectedPlayer && <span>Selected: </span>}
                {!selectedPlayer?.categorizations &&
                <strong style={{
                    wordBreak: "break-word"
                    }}>
                        {isMultipleChoiceForPlayer ? selectedMultipleString : selectedPlayer && selectedString}
                </strong>
            }
            {halfStateText}
            {selectedPlayer?.categorizations &&
                <strong style={{
                    wordBreak: "break-word",
                    marginLeft:"5px"
                    }}>{Array.from(new Set(inputItemList.map(x => x.playerScoreKey))).filter(x => selectedPlayer?.groupPlayerScoresKey?.includes(x) && x !== selectedPlayer.key && x.length > 0).join(",")
                    } {selectedScore?.text ? selectedScore?.text : selectedPlayer?.totalScoreText ? selectedPlayer?.totalScoreText : selectedPlayer.scoreText}
                </strong>
            }    
        </Col>
        <Col className="py-1">
                                
        </Col>
    </>;

}

export default PlayerUpdateList;
